import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import { Alert } from "antd";
import qs from "qs";
import PropTypes from "prop-types";
import axios from "axios";

import {
  FormContainer,
  Header,
  Footer,
  ContactUsLink,
  Spinner
} from "../../components";

class VerifyEmailSuccess extends Component {
  state = {
    success: "",
    message: "",
    email: "",
    verification: {
      processing: false,
      error: false,
      errorMsg: "",
      data: null
    }
  };

  componentDidMount() {
    const { location } = this.props;
    const query = qs.parse(location.search.replace("?", "")); //remove ? from start of location.search
    const { success, message, email } = query;

    this.setState({
      success: success,
      message: message
    });

    if (success) {
      //call backend to update on success
      const appsAPI = axios.create({
        baseURL: "https://api.apps.pdview.com.au"
      });

      const self = this;

      self.setState(
        prevState => ({
          verification: {
            ...prevState.verification,
            processing: true
          }
        }),
        () =>
          appsAPI
            .get(`/emailverified?email=${email}`)
            .then(function(response) {
              self.setState(prevState => ({
                verification: {
                  ...prevState.verification,
                  processing: false,
                  data: response.data
                }
              }));
            })
            .catch(err => {
              console.log("Error occurred while calling email verified", err);
              self.setState(prevState => ({
                verification: {
                  ...prevState.verification,
                  processing: false,
                  error: true,
                  errorMsg: err.message
                }
              }));
            })
      );
    }
  }

  render() {
    const { success, message, verification } = this.state;

    return (
      <div>
        <Header />
        <FormContainer
          formTitle={
            success.toString() === "true"
              ? "Email verified"
              : "Email verification failed"
          }
        >
          {success.toString() === "true" ? (
            <div>
              {verification.processing ? (
                <Spinner message={"Updating our database"} />
              ) : verification.error ? (
                <div>
                  <Alert
                    message={
                      verification.errorMsg
                        ? verification.errorMsg
                        : "Error while updating our records"
                    }
                    type={"warning"}
                    showIcon
                  />
                </div>
              ) : (
                <div>
                  <Alert message={message} type={"success"} showIcon />
                  <br />
                  <NavLink to={"/app/home"}>Go to Home</NavLink>
                </div>
              )}
            </div>
          ) : (
            <div>
              <Alert message={message} type={"warning"} showIcon />
              <br />
              <NavLink to={"/app/verifyemail"}>Try again</NavLink>
            </div>
          )}
          <ContactUsLink />
        </FormContainer>
        <Footer />
      </div>
    );
  }
}

VerifyEmailSuccess.propTypes = {
  location: PropTypes.object.isRequired
};

export default VerifyEmailSuccess;



// WEBPACK FOOTER //
// ./src/views/verify_email_success/VerifyEmailSuccess.jsx